import React from 'react';

import { DeliveryCategory } from '~api/api';

import { CustomText } from '~src/main/category/custom-text';
import { DeliveryTimeComponent } from '~src/main/delivery-time/delivery-time';
import { LabelExtension } from '~src/main/category/labels/label-extension';
import { LogoDeck } from '~src/main/logo/logo-deck';
import { PriceComponent } from '~src/main/price/price';
import { ShippingCard } from '~src/main/ui/shipping-card';

interface CategoryCardProps {
  category: DeliveryCategory;
}

export const CategoryCard: React.FC<CategoryCardProps> = ({ category }) => {
  const shippingMethods = category.default_prices.map(({ shipping_method }) => shipping_method);
  return (
    <ShippingCard
      title={category.name}
      logo={<LogoDeck shippingMethods={shippingMethods} />}
      price={<PriceComponent prices={category.default_prices} />}
      subtitle={<DeliveryTimeComponent deliveryTime={category.delivery_time} />}
    >
      <LabelExtension category={category} />
      {category.custom_text && <CustomText text={category.custom_text} variant="primary" />}
      {category.custom_info_text && (
        <CustomText text={category.custom_info_text} variant="secondary" />
      )}
    </ShippingCard>
  );
};
